import type { OccupiedRange } from '../../lib/planDates';
import type { MacroKey, Pct } from '../../types';

export const MACRO_KEYS: MacroKey[] = ['p', 'c', 'f'];

export const MACRO_META: Record<MacroKey, { bg: string; fg: string; label: string; kcalPerG: number }> = {
  p: { bg: '#444CE7', fg: '#fff', label: 'Protein', kcalPerG: 4 },
  c: { bg: '#E7C144', fg: '#7A2E0E', label: 'Carbs', kcalPerG: 4 },
  f: { bg: '#2D8282', fg: '#fff', label: 'Fats', kcalPerG: 9 },
};

/** Macro bar colours for mobile (same palette as desktop `MACRO_META`). */
export const MACRO_META_NATIVE: Record<MacroKey, { bg: string; label: string }> = {
  p: { bg: MACRO_META.p.bg, label: MACRO_META.p.label },
  c: { bg: MACRO_META.c.bg, label: MACRO_META.c.label },
  f: { bg: MACRO_META.f.bg, label: MACRO_META.f.label },
};

export interface GoalsPresetView {
  label: string;
  /** Chip text; standard presets include P/C/F, template is label only. */
  chipLabel: string;
  pct: Pct;
  active: boolean;
}

/** State + actions shared by the desktop and mobile Goals UIs. Produced once by `useGoalsStep`. */
export interface GoalsStepModel {
  name: string;
  from: string;
  to: string;
  kcal: number;
  pct: Pct;
  presets: GoalsPresetView[];
  sumPct: number;
  isBalanced: boolean;
  suggestion: { delta: number; pct: Pct } | null;
  applySuggestion: () => void;
  datesOk: boolean;
  datesPastStart: boolean;
  minStartDate: string;
  overlap: OccupiedRange | null;
  suggestedRange: { from: string; to: string };
  applySuggestedDates: () => void;
  grams: Record<MacroKey, number>;
  macroKcal: Record<MacroKey, number>;
  dateRangeLabel: string;
  templateHint: string | null;
  splitSummary: string;
  setName: (v: string) => void;
  setFrom: (v: string) => void;
  setTo: (v: string) => void;
  setKcal: (v: number) => void;
  stepKcal: (delta: number) => void;
  setPct: (key: MacroKey, value: number) => void;
  setGrams: (key: MacroKey, grams: number) => void;
  stepPct: (key: MacroKey, delta: number) => void;
  applyPreset: (pct: Pct, label: string) => void;
  openSplit: () => void;
}
